<template>
  <div class="transfer__wrapper transfer-payment-method">
    <!-- Шаг 1: Выбор метода оплаты -->
    <form-layout
      v-if="currentStep === 1"
      :main-title="$t('gift.title')"
      :mobile-title="$t('gift.title')"
      :small-title="true"
      submit-text="Далее"
      @back="goBack"
      @submit="goToNextStep"
    >
      <div class="payments-content__body">
        <Loader v-if="loading" />
        <div class="payments-content__body__header">
          <div class="payments-content__body__header__left">
            <div class="payments-content__body__header__image">
              <img src="@/assets/images/payments/payments-ico.svg" alt="ico" />
            </div>
            <span>
              {{ $t('payment.selectPaymentMethod') }}
            </span>
          </div>
        </div>
        <PaymentMethodsList :current="selectedMethodName" :list="methodsInCustomOrder" @select="choosePaymentMethod" />
      </div>

      <div class="payments-content__info">
        <div class="payments-content__info__wrap">
          <div class="payments-content__info__title">{{ $t('payment.replenishmentAmount') }}</div>
          <Input
            v-model.trim="amount"
            type="number"
            :icon-text="currencyMap[$store.state.currency]"
            :placeholder="$t('payment.enterSum')"
            :state="error.message ? 'error' : 'default'"
            :error="error.message"
            :disabled="true"
          />
        </div>

        <div class="payments-content__info__wrap">
          <div class="payments-content__info__title">{{ $t('payment.commission') }}:</div>
          <Input
            v-model.trim="commissionValue"
            icon-text="%"
            :placeholder="$t('payment.commission')"
            :disabled="true"
          />
        </div>
      </div>
    </form-layout>

    <!-- Шаг 2: Подтверждение -->
    <form-layout
      v-if="currentStep === 2"
      :main-title="$t('gift.title')"
      :small-title="true"
      :title="$t('gift.title')"
      :submit-text="$t('payment.pay')"
      :disabled="loading"
      @back="currentStep = 1"
      @submit="createOrder"
    >
      <div class="payments-step-2">
        <div class="payments-step-2__info">
          <div class="payments-step-2__method">
            <Input :value="paymentMethodName" :disabled="true" icon="/base/payment.svg" placeholder="Метод оплаты" />
            <span class="payments-step-2__method-commission">
              Комиссия {{ $store.state.paymentsOrder.selectedMethod.commission }}%
            </span>
          </div>

          <div class="payments-step-2__infoPay">
            <Input :value="gift.quantity + ' R$'" :disabled="true" icon="/base/robux.svg" placeholder="Робуксы" />
            <Input
              :value="amount + ' ' + currencyMap[$store.state.currency]"
              :disabled="true"
              :icon-text="currencyMap[$store.state.currency]"
              :placeholder="$t('payment.replenishmentAmount')"
            />
          </div>

          <Alert state="warning" :title="$t('general.warning')" :info="$t('gift.infoText')" />
        </div>

        <p class="payments-step-2__result">
          {{ $t('payment.toPay') }}:
          <span>
            {{ commissionValue }}
            {{ currencyMap[$store.state.currency] }}
          </span>
        </p>
      </div>
    </form-layout>
  </div>
</template>

<script>
import paymentsMethodsInfo from '@/constants/paymentsMethodsInfo'
import { getCommissionNewLava } from '@/utils/formatting'
import { getPaymentMethodName, makePayment } from '@/utils/paymentMethods'
import { mapGetters } from 'vuex'
import Loader from '@/components/LoaderBar/LoaderBar'
import Input from '@/components/Base/Input/Input.vue'
import Alert from '@/components/Base/Alert/Alert.vue'
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import PaymentMethodsList from '@/components/PaymentMethodsList/PaymentMethodsList.vue'
import { METHODS_ORDER } from '@/constants/paymentMethods'
import paymentSubStep from '@/mixins/paymentSubStep'

export default {
  name: 'GiftPaymentMethod',
  components: {
    PaymentMethodsList,
    FormLayout,
    Input,
    Alert,
    Loader
  },
  inject: ['currencyMap'],
  mixins: [paymentSubStep],
  props: {
    gift: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      currentStep: 1,
      selectedMethod: {
        name: '',
        currency: '',
        commission: 0,
        email: null,
        method: null,
        key: null
      },
      countryList: {
        RU: ['RU', 'UA', 'EU', 'USA', 'MX', 'PE', 'UY', 'CL', 'BR', 'TH', 'ID', 'PH', 'MY', 'VN', 'HK'],
        EN: ['EU', 'USA', 'UA', 'MX', 'PE', 'UY', 'CL', 'BR', 'TH', 'ID', 'PH', 'MY', 'VN', 'HK']
      },

      paymentMethod: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsToGatewayMap)),
      paymentSystemsMap: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsToSystemMap)),
      methodMaps: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsConfig)),
      allMethods: JSON.parse(JSON.stringify(paymentsMethodsInfo.allMethods)),

      filters: {
        country: 'RU',
        currency: 'RUB'
      },

      currencyRate: {
        RUB: 1,
        USD: 73,
        EUR: 80,
        EURUSD: 1,
        USDEUR: 1
      },

      amount: null,
      error: {
        status: false,
        show: false,
        message: ''
      },
      loading: false,
      newCommissions: []
    }
  },
  created() {
    this.getNewCommission()
    this.amount = this.gift.price[this.$store.state.currency]
  },
  mounted() {
    this.setUserRegion()
  },
  computed: {
    ...mapGetters(['currency', 'language', 'country']),
    paymentMethodName() {
      return getPaymentMethodName(this.selectedMethod.name)
    },
    selectedCountry() {
      return this.filters.country
    },
    filteredMethods() {
      const sortByPriority = (a, b) => {
        return this.methodMaps[a.key]?.priority[this.selectedCountry] >
          this.methodMaps[b.key]?.priority[this.selectedCountry]
          ? 1
          : -1
      }

      const generateMultiCurrencyList = methods => {
        return methods
          .map(m => ({
            key: m,
            name: m,
            currency: 'rub',
            commission: this.getMethodCommission(m),
            iconType: this.methodMaps[m].iconType,
            iconName: this.methodMaps[m].iconName,
            min: this.methodMaps[m]?.min?.default,
            email: this.methodMaps[m].email
          }))
          .flat()
      }

      let filteredMethods = this.allMethods
      if (this.filters.currency === 'ALL') {
        filteredMethods = generateMultiCurrencyList(filteredMethods)
      } else {
        filteredMethods = filteredMethods.map(m => ({
          key: m,
          currency: this.filters.currency,
          commission: this.getMethodCommission(m),
          iconType: this.methodMaps[m].iconType,
          iconName: this.methodMaps[m].iconName,
          min: this.methodMaps[m]?.min?.default
        }))
      }

      return filteredMethods
        .sort((a, b) => sortByPriority(a, b))
        .filter((item, index, self) => index === self.findIndex(obj => obj.key === item.key))
    },
    commissionValue() {
      if (!this.selectedMethod.name || !this.amount) return ''

      const method = this.selectedMethod.name

      if (this.shouldReturnUnknown(method)) return 'Unknown'
      if (this.isQiwiMethod(method)) return this.calculateQiwiCommission()

      const commission = this.calculateCommissionRate(method)
      const amount = Number(this.amount)

      const multipliedResult = this.calculateWithMultipliers(method, amount, commission)
      if (multipliedResult !== null) return multipliedResult

      if (this.paymentSystemsMap[method] === 'gm') {
        const fixFee = this.methodMaps[method]?.fix?.[this.currency] || 0
        return this.getPrice(amount, commission, fixFee).toFixed(2)
      }

      if (this.paymentSystemsMap[method] === 'gram') {
        return this.calculateGramCommission(amount)
      }

      return this.getPrice(amount, commission, 0, this.shouldUseLavaCalculation(method))
    },
    paymentIsRub() {
      return ['rub_card', 'lava', 'card_gm', 'sbp_gm', ...METHODS_ORDER].includes(this.selectedMethod.name)
    },
    methodsInCustomOrder() {
      const methods = [...this.newCommissions, ...this.filteredMethods]
      const orderedMethods = this.getMethodsWithOrder(methods)
      return orderedMethods.length ? orderedMethods : methods
    },
    selectedMethodName() {
      return this.selectedMethod.method || this.selectedMethod.key
    }
  },
  watch: {
    'selectedMethod.name': function(val) {
      if (val) {
        const minVar = this.methodMaps[val].min
        let minVal = null
        if (typeof minVar === 'object') {
          minVal = minVar[this.currency.toUpperCase()]
        } else {
          minVal = minVar
        }
        const giftPrice = this.gift.price[this.$store.state.currency]
        this.amount = giftPrice >= minVal ? giftPrice : this.ceil(minVal, 2)
      }
    }
  },
  methods: {
    getCommissionNewLava,

    goBack() {
      this.$emit('changeModal', { modal: 'MainForm' })
    },

    goToNextStep() {
      if (!this.selectedMethod.name) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('payment.errors.empty'),
          type: 'error'
        })
        return
      }

      this.$store.commit('paymentsOrder/setAmount', Number(this.amount))
      this.$store.commit('paymentsOrder/setCurrency', this.currency)
      this.$store.commit('paymentsOrder/setSelectedMethod', {
        name: this.selectedMethod.name,
        key: this.selectedMethod.key,
        commission: this.selectedMethod.commission,
        iconType: this.selectedMethod.iconType,
        iconName: this.selectedMethod.iconName
      })
      this.$store.commit('paymentsOrder/setCommission', this.commissionValue)
      this.$store.commit('paymentsOrder/setTotalToPay', this.commissionValue)

      this.currentStep = 2
    },

    async createOrder() {
      if (!this.selectedMethod.name) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('payment.errors.empty'),
          type: 'error'
        })
        return
      }

      this.loading = true

      try {
        const requestHeaders = new Headers({
          Authorization: `Bearer ${this.$cookies.get('access_token')}`
        })

        const response = await fetch(
          `https://transfer.backend-pier.com/make_key_order?quantity=${this.gift.quantity}&platform=${this.gift.platform}&category=${this.gift.category}&flag=true`,
          { method: 'GET', headers: requestHeaders }
        )
        const orderResult = await response.json()

        if (!orderResult || orderResult.status === false) {
          const errorMessage = orderResult?.message || orderResult?.error || this.$t('payment.errors.server')
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: errorMessage,
            type: 'error'
          })
          return
        }

        const orderId =
          orderResult?.order_id ||
          orderResult?.order?._id ||
          orderResult?.data?._id ||
          orderResult?.data?.id ||
          orderResult?.id

        if (!orderId) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: this.$t('payment.errors.server'),
            type: 'error'
          })
          return
        }

        const userId = this.$store.state.account.userId

        if (!userId) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: this.$t('payment.errors.server'),
            type: 'error'
          })
          return
        }

        const paymentResult = await makePayment(
          {
            name: this.selectedMethod.name,
            key: this.selectedMethod.key,
            method: this.selectedMethod.method
          },
          orderId,
          userId,
          Number(this.amount),
          null,
          this.currency
        )

        if (paymentResult?.redirect_uri) {
          this.$analytics.send('topup', {
            topup_id: paymentResult.id || orderId,
            source: 'gift'
          })
          location.href = paymentResult.redirect_uri
        } else {
          this.$analytics.send('topup_error', { source: 'gift' })
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: this.$t('payment.errors.server'),
            type: 'error'
          })
        }
      } catch (error) {
        this.$analytics.send('topup_error', { source: 'gift' })
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('payment.errors.server'),
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },

    setUserRegion() {
      const EU_COUNTRIES = [
        'AU',
        'BE',
        'BG',
        'GB',
        'HU',
        'DE',
        'GR',
        'DK',
        'IE',
        'ES',
        'IT',
        'LV',
        'LT',
        'LU',
        'MT',
        'LI',
        'NL',
        'PL',
        'PT',
        'RO',
        'SK',
        'SI',
        'FI',
        'FR',
        'HR',
        'CZ',
        'SE',
        'EE',
        'BA',
        'IS',
        'NO'
      ]
      const RU_COUNTRIES = ['AZ', 'AM', 'BY', 'KZ', 'KG', 'MD', 'TJ', 'UZ', 'TM', 'GE']
      const SELECTED_COUNTRIES = ['RU', 'UA', 'EU', 'USA', 'MX', 'PE', 'UY', 'CL', 'BR']

      if (EU_COUNTRIES.includes(this.country)) {
        this.filters.country = 'EU'
      } else if (RU_COUNTRIES.includes(this.country)) {
        this.filters.country = 'RU'
      } else if (SELECTED_COUNTRIES.includes(this.country)) {
        this.filters.country = this.country
      } else {
        this.filters.country = 'RU'
      }
    },

    ceil(value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },

    getMethodCommission(method) {
      if (typeof this.methodMaps[method].commission === 'object') {
        const key = Object.keys(this.methodMaps[method].commission)
        if (key.includes(this.filters.country)) {
          return this.methodMaps[method].commission[this.filters.country]
        }
        return this.methodMaps[method].commission.default
      }
      return this.methodMaps[method].commission
    },

    choosePaymentMethod(method) {
      this.selectedMethod.method = null
      this.selectedMethod.percent = null
      this.selectedMethod.status = null

      this.error = { status: false, show: false, message: '' }

      this.selectedMethod.name = method.key
      this.selectedMethod.key = method.key
      this.selectedMethod.method = method.key
      this.selectedMethod.currency = method.currency
      this.selectedMethod.commission = method.commission
      this.selectedMethod.iconType = method.iconType
      this.selectedMethod.min = method.min
      this.selectedMethod.email = method.email
      this.selectedMethod.iconName = method.iconName
    },

    async getNewCommission() {
      try {
        const response = await fetch('https://payments.backend-pier.com/api/v1/topups/lava_commissions')
        const data = await response.json()
        const { commissions } = data
        this.newCommissions = commissions
          ?.filter(item => item.status)
          .map(item => ({ ...item, name: 'lava', key: 'lava_' + item.method }))
      } catch (error) {
        console.error('Error fetching commissions:', error)
      }
    },

    getMethodsWithOrder(currentList) {
      const filteredList = []
      METHODS_ORDER.forEach(methodName => {
        const method = currentList.find(item => item.key === methodName)
        if (method) filteredList.push(method)
      })
      return filteredList
    },

    shouldReturnUnknown(method) {
      return ['new_fk', 'payok'].includes(method)
    },

    isQiwiMethod(method) {
      return method === 'qiwi'
    },

    calculateQiwiCommission() {
      const commission = this.methodMaps.qiwi.commission
      return Math.ceil((Number(this.amount) + (this.amount * commission) / 100) * 100) / 100
    },

    calculateCommissionRate(method) {
      if (this.selectedMethod.percent) {
        return Number(1 - this.selectedMethod.percent) * 100
      }
      const methodCommission = this.methodMaps[method]?.commission
      if (typeof methodCommission !== 'object') return methodCommission
      return methodCommission[this.filters.country] || methodCommission.default
    },

    getPrice(amount, commission, multiplier = 0, useLavaFormula = false) {
      if (useLavaFormula) {
        return Number((amount / (1 - commission / 100)).toFixed(2))
      }
      return Number((amount + (amount * commission) / 100 + multiplier).toFixed(2))
    },

    shouldUseLavaCalculation(method) {
      return this.selectedMethod.percent || ['cardlink', 'cardlink_sbp', 'cardlink_copy', 'lava'].includes(method)
    },

    calculateWithMultipliers(method, amount, commission) {
      const multipliers = {
        redpagos: { RUB: 0.5 * this.currencyRate.USD, EUR: 0.5 * this.currencyRate.USDEUR, USD: 0.5 },
        servipag: { RUB: 1.5 * this.currencyRate.USD, EUR: 1.5 * this.currencyRate.USDEUR, USD: 1.5 },
        boleto: { RUB: this.currencyRate.USD, EUR: this.currencyRate.USDEUR, USD: 1 }
      }

      if (multipliers[method] && multipliers[method][this.currency]) {
        return this.getPrice(amount, commission, multipliers[method][this.currency])
      }

      if (method === 'card_gm') {
        return this.calculateCardGmCommission(amount, commission)
      }

      return null
    },

    calculateCardGmCommission(amount, commission) {
      const cardGmMultipliers = {
        EU: { RUB: 0.1 * this.currencyRate.EUR, EUR: 0.1, USD: 0.1 * this.currencyRate.EURUSD },
        default: { RUB: 0.12 * this.currencyRate.EUR, EUR: 0.12, USD: 0.12 * this.currencyRate.EURUSD }
      }

      const multiplierConfig = ['RU', 'UA', 'EU'].includes(this.filters.country)
        ? cardGmMultipliers.EU
        : cardGmMultipliers.default

      if (multiplierConfig[this.currency]) {
        return this.getPrice(amount, commission, multiplierConfig[this.currency])
      }

      return null
    },

    calculateGramCommission(amount) {
      const c = Number(amount / 7).toFixed(2)
      const minCommission = 4.9 / this.currencyRate[this.currency]
      if (c > minCommission) {
        return Math.ceil((amount + Number(c)) * 100) / 100
      }
      return Math.ceil((amount + minCommission) * 100) / 100
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../Transfer/transferPaymentMethod/transferPaymentMethod.scss';
</style>
